export default "/_next/static/images/fc94a9694b57820367775dda5d67a6dc.jpg";